/*MIT License

Copyright (c) 2018 Rosalind Wills

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	value: PropTypes.string.isRequired,
	handleItemRemove: PropTypes.func.isRequired,
	deleteButton: PropTypes.node.isRequired
};

const MultipleValueTextInputItem = (props) => {
	const { value, handleItemRemove, deleteButton } = props;
	return (
		<div className="multiple-value-text-input-item">
			<span className='multiple-value-text-input-item-content'>{value}{' '}</span>
			<span
				className="multiple-value-text-input-item-delete-button"
				data-value={value}
				tabIndex="-1"
				role="button"
				onKeyPress={() => handleItemRemove(value)}
				onClick={() => handleItemRemove(value)}
			>
				{deleteButton}
			</span>
		</div>
	);
};

MultipleValueTextInputItem.propTypes = propTypes;
export default MultipleValueTextInputItem;
